<div class="can-hide-navigation">
    <div class="toolbar-container">
        <div class="toolbar">
            <div class="title-container" style="display: flex;">
                <h2>Contract Management Excel</h2>
                <a class="Uploadtemplate" 
                   *ngIf="isUpload"
                   [class.disabled]="isUploading" 
                   (click)="upload()" 
                   [style.pointer-events]="isUploading ? 'none' : 'auto'"
                   [style.opacity]="isUploading ? '0.6' : '1'">
                   {{ isUploading ? "上传中..." : i18n.t("js.cunstom-forms.uploadbutton") }}
                </a>
                <a class="download-excel" href="/api/v3/projects/9/excel/download">Download Excel</a>
            </div>
        </div>
    </div>
    <div class="isload">
      <cunstom-forms-loading ></cunstom-forms-loading>
    </div>
    <div class="item-content">
        <table>
            <tr>
                 <th>id</th>
                <th style="text-align: left;">{{ i18n.t("js.cunstom-forms.title") }}</th>
                <th>{{ i18n.t("js.cunstom-forms.createdDate") }}</th>
                <th>{{ i18n.t("js.cunstom-forms.creator") }}</th>
                <!-- <th>{{ i18n.t("js.cunstom-forms.action") }}</th> -->
            </tr>
            <tr *ngFor="let item of tableData">
                <td>{{item.id}}</td>
                <td><a>{{item.filename}}</a></td>
                <td>{{item.created_at}}</td>
                <td>{{item.upload_user.name}}</td>
                <!-- <td (click)="delete(item)"><a>{{ i18n.t("js.cunstom-forms.deletebutton") }}</a></td> -->
            </tr>
        </table>
        <div id="page"></div> 
    </div>
</div>